'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _hints = require('../actions/hints');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(createHint),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(editHint),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplineSubjects),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplineSummaries),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplineModels),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplineSynopses),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(fetchLawClauses),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(fetchHint),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(fetchHints),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(createHintRequest),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(editHintRequest),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplineSubjectsRequest),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplineSummariesRequest),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplineModelsRequest),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(fetchDisciplineSynopsesRequest),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(fetchLawClausesRequest),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(fetchHintRequest),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(fetchHintsRequest);

function createHint(_ref) {
    var hint = _ref.hint,
        filter = _ref.filter;
    var questions, questionsResponse, questionsNotFound;
    return regeneratorRuntime.wrap(function createHint$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    questions = void 0;

                    if (!(hint.questions.length === 0)) {
                        _context.next = 6;
                        break;
                    }

                    questions = [];
                    _context.next = 10;
                    break;

                case 6:
                    _context.next = 8;
                    return (0, _effects.call)(_api.request, 'get', '/questions?filter[ids]=' + hint.questions.join(','));

                case 8:
                    questionsResponse = _context.sent;

                    questions = questionsResponse.data;

                case 10:
                    if (!(questions.length !== hint.questions.length)) {
                        _context.next = 16;
                        break;
                    }

                    questionsNotFound = hint.questions.filter(function (question) {

                        return questions.find(function (q) {
                            return q.id === question;
                        }) === undefined;
                    });
                    _context.next = 14;
                    return (0, _effects.put)(_hints.actionCreators.createHintFailed('As quest\xF5es com id\'s [' + questionsNotFound.join(', ') + '] n\xE3o foram encontradas'));

                case 14:
                    _context.next = 22;
                    break;

                case 16:
                    _context.next = 18;
                    return (0, _effects.call)(_api.request, 'post', '/hints', hint);

                case 18:
                    _context.next = 20;
                    return (0, _effects.put)(_hints.actionCreators.createHintSucceeded());

                case 20:
                    _context.next = 22;
                    return (0, _effects.put)(_hints.actionCreators.fetchHintsRequest(filter));

                case 22:
                    _context.next = 28;
                    break;

                case 24:
                    _context.prev = 24;
                    _context.t0 = _context['catch'](0);
                    _context.next = 28;
                    return (0, _effects.put)(_hints.actionCreators.createHintFailed('Ocorreu um erro inesperado durante a criação da dica.'));

                case 28:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 24]]);
}

function editHint(_ref2) {
    var hint = _ref2.hint,
        filter = _ref2.filter;
    var questions, questionsResponse, questionsNotFound;
    return regeneratorRuntime.wrap(function editHint$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    questions = void 0;

                    if (!(hint.questions.length === 0)) {
                        _context2.next = 6;
                        break;
                    }

                    questions = [];
                    _context2.next = 10;
                    break;

                case 6:
                    _context2.next = 8;
                    return (0, _effects.call)(_api.request, 'get', '/questions?filter[ids]=' + hint.questions.join(','));

                case 8:
                    questionsResponse = _context2.sent;

                    questions = questionsResponse.data;

                case 10:
                    if (!(questions.length !== hint.questions.length)) {
                        _context2.next = 16;
                        break;
                    }

                    questionsNotFound = hint.questions.filter(function (question) {

                        return questions.find(function (q) {
                            return q.id === question;
                        }) === undefined;
                    });
                    _context2.next = 14;
                    return (0, _effects.put)(_hints.actionCreators.editHintFailed('As quest\xF5es com id\'s [' + questionsNotFound.join(', ') + '] n\xE3o foram encontradas'));

                case 14:
                    _context2.next = 22;
                    break;

                case 16:
                    _context2.next = 18;
                    return (0, _effects.call)(_api.request, 'put', '/hints/' + hint.id, hint);

                case 18:
                    _context2.next = 20;
                    return (0, _effects.put)(_hints.actionCreators.editHintSucceeded());

                case 20:
                    _context2.next = 22;
                    return (0, _effects.put)(_hints.actionCreators.fetchHintsRequest(filter));

                case 22:
                    _context2.next = 28;
                    break;

                case 24:
                    _context2.prev = 24;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 28;
                    return (0, _effects.put)(_hints.actionCreators.editHintFailed('Ocorreu um erro inesperado durante a edição da dica.'));

                case 28:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 24]]);
}

function fetchDisciplineSubjects(_ref3) {
    var disciplineId = _ref3.disciplineId;
    var response, subjects;
    return regeneratorRuntime.wrap(function fetchDisciplineSubjects$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/subjects?disciplines=' + disciplineId);

                case 3:
                    response = _context3.sent;
                    subjects = response.data.reduce(function (aggr, subject) {

                        aggr[subject.id] = subject;
                        return aggr;
                    }, {});
                    _context3.next = 7;
                    return (0, _effects.put)(_hints.actionCreators.fetchDisciplineSubjectsSucceeded(subjects));

                case 7:
                    _context3.next = 13;
                    break;

                case 9:
                    _context3.prev = 9;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 13;
                    return (0, _effects.put)(_hints.actionCreators.fetchDisciplineSubjectsFailed());

                case 13:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 9]]);
}

function fetchDisciplineSummaries(_ref4) {
    var disciplineId = _ref4.disciplineId;
    var response, summaries;
    return regeneratorRuntime.wrap(function fetchDisciplineSummaries$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/summaries?disciplineId=' + disciplineId);

                case 3:
                    response = _context4.sent;
                    summaries = response.data.reduce(function (aggr, summary) {

                        aggr[summary.id] = summary;
                        return aggr;
                    }, {});
                    _context4.next = 7;
                    return (0, _effects.put)(_hints.actionCreators.fetchDisciplineSummariesSucceeded(summaries));

                case 7:
                    _context4.next = 13;
                    break;

                case 9:
                    _context4.prev = 9;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 13;
                    return (0, _effects.put)(_hints.actionCreators.fetchDisciplineSummariesFailed());

                case 13:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 9]]);
}

function fetchDisciplineModels(_ref5) {
    var disciplineId = _ref5.disciplineId;
    var response, models;
    return regeneratorRuntime.wrap(function fetchDisciplineModels$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.prev = 0;
                    _context5.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/models?disciplineId=' + disciplineId);

                case 3:
                    response = _context5.sent;
                    models = response.data.reduce(function (aggr, model) {

                        aggr[model.id] = model;
                        return aggr;
                    }, {});
                    _context5.next = 7;
                    return (0, _effects.put)(_hints.actionCreators.fetchDisciplineModelsSucceeded(models));

                case 7:
                    _context5.next = 13;
                    break;

                case 9:
                    _context5.prev = 9;
                    _context5.t0 = _context5['catch'](0);
                    _context5.next = 13;
                    return (0, _effects.put)(_hints.actionCreators.fetchDisciplineModelsFailed());

                case 13:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[0, 9]]);
}

function fetchDisciplineSynopses(_ref6) {
    var disciplineId = _ref6.disciplineId;
    var response, synopses;
    return regeneratorRuntime.wrap(function fetchDisciplineSynopses$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.prev = 0;
                    _context6.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/synopses?disciplineId=' + disciplineId);

                case 3:
                    response = _context6.sent;
                    synopses = response.data.reduce(function (aggr, synopsis) {

                        aggr[synopsis.id] = synopsis;
                        return aggr;
                    }, {});
                    _context6.next = 7;
                    return (0, _effects.put)(_hints.actionCreators.fetchDisciplineSynopsesSucceeded(synopses));

                case 7:
                    _context6.next = 13;
                    break;

                case 9:
                    _context6.prev = 9;
                    _context6.t0 = _context6['catch'](0);
                    _context6.next = 13;
                    return (0, _effects.put)(_hints.actionCreators.fetchDisciplineSynopsesFailed());

                case 13:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this, [[0, 9]]);
}

function fetchLawClauses(_ref7) {
    var lawId = _ref7.lawId;
    var response, clauses;
    return regeneratorRuntime.wrap(function fetchLawClauses$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.prev = 0;
                    _context7.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/clauses?lawId=' + lawId);

                case 3:
                    response = _context7.sent;
                    clauses = response.data.reduce(function (aggr, clause) {

                        aggr[clause.id] = clause;
                        return aggr;
                    }, {});
                    _context7.next = 7;
                    return (0, _effects.put)(_hints.actionCreators.fetchLawClausesSucceeded(clauses));

                case 7:
                    _context7.next = 13;
                    break;

                case 9:
                    _context7.prev = 9;
                    _context7.t0 = _context7['catch'](0);
                    _context7.next = 13;
                    return (0, _effects.put)(_hints.actionCreators.fetchLawClausesFailed());

                case 13:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this, [[0, 9]]);
}

function fetchHint(_ref8) {
    var hintId = _ref8.hintId;
    var response;
    return regeneratorRuntime.wrap(function fetchHint$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.prev = 0;
                    _context8.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/hints/' + hintId);

                case 3:
                    response = _context8.sent;
                    _context8.next = 6;
                    return (0, _effects.put)(_hints.actionCreators.fetchHintSucceeded(response.data));

                case 6:
                    _context8.next = 12;
                    break;

                case 8:
                    _context8.prev = 8;
                    _context8.t0 = _context8['catch'](0);
                    _context8.next = 12;
                    return (0, _effects.put)(_hints.actionCreators.fetchHintFailed('Ocorreu um erro inesperado durante a busca da dica.'));

                case 12:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this, [[0, 8]]);
}

function fetchHints(_ref9) {
    var filter = _ref9.filter;
    var getParams, response;
    return regeneratorRuntime.wrap(function fetchHints$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.prev = 0;
                    getParams = [];

                    Object.keys(filter).forEach(function (filterKey) {
                        var value = filter[filterKey];
                        if (value) {
                            getParams.push(filterKey + '=' + value);
                        }
                    });

                    _context9.next = 5;
                    return (0, _effects.call)(_api.request, 'get', '/hints?' + getParams.join('&'));

                case 5:
                    response = _context9.sent;
                    _context9.next = 8;
                    return (0, _effects.put)(_hints.actionCreators.fetchHintsSucceeded(response.data, filter));

                case 8:
                    _context9.next = 14;
                    break;

                case 10:
                    _context9.prev = 10;
                    _context9.t0 = _context9['catch'](0);
                    _context9.next = 14;
                    return (0, _effects.put)(_hints.actionCreators.fetchHintsFailed());

                case 14:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this, [[0, 10]]);
}

function createHintRequest() {
    return regeneratorRuntime.wrap(function createHintRequest$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(_hints.actionTypes.CREATE_HINT_REQUEST, createHint);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function editHintRequest() {
    return regeneratorRuntime.wrap(function editHintRequest$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    _context11.next = 2;
                    return (0, _effects.takeLatest)(_hints.actionTypes.EDIT_HINT_REQUEST, editHint);

                case 2:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function fetchDisciplineSubjectsRequest() {
    return regeneratorRuntime.wrap(function fetchDisciplineSubjectsRequest$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeLatest)(_hints.actionTypes.FETCH_DISCIPLINE_SUBJECTS_REQUEST, fetchDisciplineSubjects);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

function fetchDisciplineSummariesRequest() {
    return regeneratorRuntime.wrap(function fetchDisciplineSummariesRequest$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    _context13.next = 2;
                    return (0, _effects.takeLatest)(_hints.actionTypes.FETCH_DISCIPLINE_SUMMARIES_REQUEST, fetchDisciplineSummaries);

                case 2:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

function fetchDisciplineModelsRequest() {
    return regeneratorRuntime.wrap(function fetchDisciplineModelsRequest$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _context14.next = 2;
                    return (0, _effects.takeLatest)(_hints.actionTypes.FETCH_DISCIPLINE_MODELS_REQUEST, fetchDisciplineModels);

                case 2:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

function fetchDisciplineSynopsesRequest() {
    return regeneratorRuntime.wrap(function fetchDisciplineSynopsesRequest$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    _context15.next = 2;
                    return (0, _effects.takeLatest)(_hints.actionTypes.FETCH_DISCIPLINE_SYNOPSES_REQUEST, fetchDisciplineSynopses);

                case 2:
                case 'end':
                    return _context15.stop();
            }
        }
    }, _marked15, this);
}

function fetchLawClausesRequest() {
    return regeneratorRuntime.wrap(function fetchLawClausesRequest$(_context16) {
        while (1) {
            switch (_context16.prev = _context16.next) {
                case 0:
                    _context16.next = 2;
                    return (0, _effects.takeLatest)(_hints.actionTypes.FETCH_LAW_CLAUSES_REQUEST, fetchLawClauses);

                case 2:
                case 'end':
                    return _context16.stop();
            }
        }
    }, _marked16, this);
}

function fetchHintRequest() {
    return regeneratorRuntime.wrap(function fetchHintRequest$(_context17) {
        while (1) {
            switch (_context17.prev = _context17.next) {
                case 0:
                    _context17.next = 2;
                    return (0, _effects.takeLatest)(_hints.actionTypes.FETCH_HINT_REQUEST, fetchHint);

                case 2:
                case 'end':
                    return _context17.stop();
            }
        }
    }, _marked17, this);
}

function fetchHintsRequest() {
    return regeneratorRuntime.wrap(function fetchHintsRequest$(_context18) {
        while (1) {
            switch (_context18.prev = _context18.next) {
                case 0:
                    _context18.next = 2;
                    return (0, _effects.takeLatest)(_hints.actionTypes.FETCH_HINTS_REQUEST, fetchHints);

                case 2:
                case 'end':
                    return _context18.stop();
            }
        }
    }, _marked18, this);
}

exports.default = [createHintRequest, editHintRequest, fetchDisciplineSubjectsRequest, fetchDisciplineSummariesRequest, fetchDisciplineModelsRequest, fetchDisciplineSynopsesRequest, fetchLawClausesRequest, fetchHintRequest, fetchHintsRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/hints.js
// module id = 2221
// module chunks = 0